export enum QuestionTypes {
    ConditionalAnswers = 1,
    MultipleAnswers = 2,
    SingleAnswer = 3
}